module.exports = __webpack_public_path__ + "8a24fb0179340f2d94159e688e5a8868.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/work_24.svg
// module id = 1427
// module chunks = 74